import { IReduxAction } from '../../views/interfaces';
import { GET_LISTINGS_DATA_SUCCESS } from '../actions';

const initialState = {
  data: null  
};

export const listingsDataReducer = (state = initialState, { type, payload }: IReduxAction) => {
  switch (type) {
    case GET_LISTINGS_DATA_SUCCESS: {
      return { ...state, data: payload };
    }
    default:
      return state;
  }
}; 